import { render, staticRenderFns } from "./AddClientFormVoluntary.vue?vue&type=template&id=30b8c81a&"
import script from "./AddClientFormVoluntary.vue?vue&type=script&lang=js&"
export * from "./AddClientFormVoluntary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports